export default "* Følelser\n* Ansigtsudtryk";